import type { DocumentVersion } from "@superego/backend";
import { ContentSummaryUtils } from "@superego/shared-utils";
import { FormattedMessage } from "react-intl";
import ContentSummaryPropertyValue from "../ContentSummaryPropertyValue/ContentSummaryPropertyValue.js";
import * as cs from "./ContentSummary.css.js";

interface Props {
  contentSummary: DocumentVersion["contentSummary"];
}
export default function ContentSummary({ contentSummary }: Props) {
  if (!contentSummary.success) {
    const { error } = contentSummary;
    return (
      <div className={cs.ContentSummary.root}>
        <FormattedMessage
          defaultMessage="Error deriving content summary: {error}"
          values={{ error: error.name }}
        />
        {error.name === "ExecutingTypescriptFunctionFailed" ? (
          <pre>{error.details.message}</pre>
        ) : null}
      </div>
    );
  }
  return (
    <dl className={cs.ContentSummary.root}>
      {ContentSummaryUtils.getSortedProperties([contentSummary]).map(
        ({ name, label }) => (
          <div key={name} className={cs.ContentSummary.property}>
            <dt className={cs.ContentSummary.propertyName}>{label}</dt>
            <dd className={cs.ContentSummary.propertyValue}>
              <ContentSummaryPropertyValue value={contentSummary.data[name]} />
            </dd>
          </div>
        ),
      )}
    </dl>
  );
}
